import { ErrorBoundary } from "@/components/common/ErrorBoundary";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link, Outlet } from "react-router-dom";

export function PlayerLayout() {
	const { t } = useTranslation();

	return (
		<div className="flex min-h-dvh flex-col bg-bg-base">
			<a href="#player-content" className="skip-to-content">
				{t("nav.skipToContent")}
			</a>
			<header className="flex h-12 items-center border-b border-border-subtle bg-bg-surface px-4">
				<Link
					to="/"
					className="flex items-center gap-2 text-sm text-secondary transition-colors hover:text-primary"
				>
					<ArrowLeft className="h-4 w-4" aria-hidden="true" />
					{t("nav.backToDashboard")}
				</Link>
			</header>
			<main id="player-content" className="flex-1">
				<ErrorBoundary>
					<Outlet />
				</ErrorBoundary>
			</main>
		</div>
	);
}
